import { Heading, Para, Stack } from 'ui-components';
import { InvalidCoupon } from '../InvalidCoupon';
import ExpirationDate from '../ExpirationDate';
import RedemptionSteps from './RedemptionSteps';
import { InputFieldCopier } from '../InputFieldCopier';
import CutNowButton from '../CutNowButton';
import { Maybe, ReferralCouponFragment } from 'drycut-graphql';
import Action from './Action';

type Props = {
  coupon?: Maybe<ReferralCouponFragment>;
};

export function Redemption({ coupon }: Props): React.ReactElement {
  const validCoupon = coupon?.type === 'Coupons::NewCustomerReferral' && !coupon.expired;

  if (!validCoupon) {
    return <InvalidCoupon couponExpired={!!coupon?.expired} expiresAt={coupon?.expiresAt} />;
  }

  return (
    <Stack gap={6} className="items-center text-center text-pretty">
      <Heading variant="h2">13 CHF Gutschein für Deinen ersten DRYCUT</Heading>

      <Stack gap={2}>
        <Para>
          {coupon.customer?.name} schenkt Dir einen{' '}
          <strong className="font-aribaubold">13 CHF Gutschein</strong> von DRYCUT. Damit bekomst Du
          Deinen ersten DRYCUT für 29 CHF statt 42 CHF.
        </Para>

        <RedemptionSteps coupon={coupon} />

        <Stack gap={4} className="my-4">
          <Action title="Direkt einlösen">
            <CutNowButton couponCode={coupon.code} width={52} className="items-start" />
          </Action>

          <Action title="Gutscheincode">
            <InputFieldCopier textToCopy={coupon.code} className="max-w-52 tracking-wider" />
          </Action>
        </Stack>

        <ExpirationDate couponExpiration={coupon.expiresAt} />
      </Stack>
    </Stack>
  );
}
